import styled from 'styled-components';
import { spacing, body2, heading3, colors, H4 } from 'ui/theme';
import { Tooltip } from 'ui/tooltip/Tooltip';
import { Card } from './Card';

// Analytics cards styles
export const AnalyticsCardContainer = styled(Card)`
  padding: ${spacing.plusHalf};
  background: ${colors.backgroundPrimary};
  border-radius: ${spacing.half};
  position: relative;
`;

export const ToggletipContainer = styled.div`
  position: absolute;
  top: ${spacing.plusHalf};
  right: ${spacing.plusHalf};
`;

export const CardHeader = styled.div`
  ${body2}
  color: ${colors.textSecondary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const StyledTooltip = styled(Tooltip)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
`;

export const ValueText = styled.div`
  ${heading3}
  font-feature-settings: "tnum";
  margin-top: ${spacing.half};
`;

export const AnalyticsCardGroupContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(${spacing.x16}, 1fr));
  gap: ${spacing.plusHalf};
`;

export const TooltipHeading = styled(H4)`
  color: ${colors.textOnColor};
`;
